
import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class BackupService {


    static SaveBackup(CompanyCode, email, restore) {
        var data = {
            CompanyCode:CompanyCode, 
            email: email,
            restore: restore
        };
        return axios.post( BaseUrl + 'Backup', data);
    }

}


// WEBPACK FOOTER //
// ./src/Services/BackupService/backupService.js